<template>
	<div class="stickycomponent">
		<v-card class="elevation-0 pa-0 mb-6">
			<v-sheet height="64">
				<v-toolbar flat color="white" class="responsive-toolbar">
					<v-btn icon @click="refreshCalander"><v-icon>mdi-refresh</v-icon></v-btn>
					<v-toolbar-title class="font-weight-bold">{{ title }}</v-toolbar-title>
					<v-btn fab text small color="grey" @click="prev">
						<v-icon small>mdi-arrow-left</v-icon>
					</v-btn>
					<v-btn fab text small color="grey" @click="next">
						<v-icon small>mdi-arrow-right</v-icon>
					</v-btn>
					<v-spacer></v-spacer>
					<div v-if="$vuetify.breakpoint.width >= 1264" class="d-flex flex-row justify-end grey--text lighten-1">
						<span class="mr-2"> <v-icon small color="light-green darken-1">mdi-circle</v-icon> Confirmed Booking </span>

						<span class="mr-2"> <v-icon small ma-2 color="light-blue darken-2">mdi-circle</v-icon> Booking Request </span>

						<span class="mr-2"> <v-icon small ma-2 color="primary">mdi-circle</v-icon> Available </span>
					</div>
					<v-btn outlined class="mr-2" color="grey darken-2" @click="setToday">Today</v-btn>
					<v-menu bottom right>
						<template #activator="{ on }">
							<v-btn outlined color="grey darken-2" v-on="on">
								<span>{{ typeToLabel[type] }}</span>
								<v-icon right>mdi-menu-down</v-icon>
							</v-btn>
						</template>

						<v-list>
							<v-list-item @click="type = 'day'">
								<v-list-item-title>Day</v-list-item-title>
							</v-list-item>
							<v-list-item @click="type = 'week'">
								<v-list-item-title>Week</v-list-item-title>
							</v-list-item>
							<v-list-item @click="type = 'month'">
								<v-list-item-title>Month</v-list-item-title>
							</v-list-item>
							<v-list-item @click="type = '4day'">
								<v-list-item-title>4 days</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-toolbar>
			</v-sheet>
			<v-sheet v-if="$vuetify.breakpoint.width < 1264" height="32">
				<div class="d-flex flex-row justify-center grey--text lighten-1">
					<span class="mr-1"> <v-icon small color="light-green darken-1">mdi-circle</v-icon> Confirmed Booking </span>

					<span class="mr-1"> <v-icon small ma-2 color="light-blue darken-2">mdi-circle</v-icon> Booking Request </span>

					<span class="mr-1"> <v-icon small ma-2 color="primary">mdi-circle</v-icon> Available </span>
				</div>
			</v-sheet>
			<v-sheet height="600">
				<v-calendar
					ref="calendar"
					v-model="focus"
					color="primary"
					:events="events"
					:event-color="getEventColor"
					:now="today"
					:type="type"
					:event-height="20"
					:short-weekdays="false"
					@click:event="showEvent"
					@click:more="viewDay"
					@click:date="viewDay"
					@change="updateRange"
				>
				</v-calendar>

				<v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
					<v-card color="grey lighten-4" min-width="350px" flat>
						<v-toolbar :color="selectedEvent.color" dark>
							<v-btn icon>
								<v-icon>mdi-pencil</v-icon>
							</v-btn>
							<v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn icon>
								<v-icon>mdi-trash</v-icon>
							</v-btn>
							<v-btn icon>
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</v-toolbar>
						<v-card-text>
							<span>{{ selectedEvent.details }}</span>
						</v-card-text>
					</v-card>
				</v-menu>
			</v-sheet>
		</v-card>
	</div>
</template>

<script>
import { Booking } from '@/models/booking.model';

import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { bus } from '@/main';
import store from '@/store';

export default {
	name: 'LocumDashboardBigCalendar',

	data: () => ({
		today: null,
		API_URL: store.getters.getAPI,
		focus: '',
		type: 'month',
		typeToLabel: {
			month: 'Month',
			week: 'Week',
			day: 'Day',
			'4day': '4 Days',
		},
		start: null,
		end: null,
		selectedEvent: {},
		selectedElement: null,
		selectedOpen: false,
		confirmedBookings: [],
		bookings: [],
		avails: [],
		bookingRequests: [],
		applicationsSent: [],
	}),

	computed: {
		...mapGetters('bookings', ['professionalConfirmedBookings', 'professionalBookingsRequests']),

		...mapGetters('availability', ['professionalAvailability']),

		title() {
			const { start, end } = this;
			if (!start || !end) {
				return '';
			}

			const startMonth = this.monthFormatter(start);
			const endMonth = this.monthFormatter(end);
			const suffixMonth = startMonth === endMonth ? '' : endMonth;

			const startYear = start.year;
			const endYear = end.year;
			const suffixYear = startYear === endYear ? '' : endYear;

			const startDay = start.day + this.nth(start.day);
			const endDay = end.day + this.nth(end.day);

			switch (this.type) {
				case 'month':
					return `${startMonth} ${startYear}`;
				case 'week':
				case '4day':
					return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
				case 'day':
					return `${startMonth} ${startDay} ${startYear}`;
			}
			return '';
		},

		monthFormatter() {
			return this.$refs.calendar.getFormatter({
				timeZone: 'UTC',
				month: 'long',
			});
		},

		events() {
			return [...this.bookings, ...this.avails, ...this.bookingRequests, ...this.applicationsSent];
		},
	},

	async created() {
		let start = moment().startOf('month');
		let end = moment().endOf('month');
		this.updateRange({ start, end });
		bus.$on('UpdateCalendar', this.refreshCalander);
	},

	mounted() {
		this.$refs.calendar.checkChange();
	},

	destroyed() {
		bus.$off('UpdateCalendar');
	},

	methods: {
		...mapActions('bookings', ['LoadProfessionalBookings']),

		...mapActions('availability', ['LoadProfessionalAvailability']),

		...mapActions('offers', ['SearchOffers', 'FetchOffers']),

		viewDay({ date }) {
			this.focus = date;
			this.type = 'day';
		},

		getEventColor(event) {
			return event.color;
		},

		setToday() {
			this.focus = this.today;
		},

		prev() {
			this.$refs.calendar.prev();
		},

		next() {
			this.$refs.calendar.next();
		},

		showEvent({ nativeEvent, event }) {
			const open = () => {
				const { eventObject } = event;
				store.commit('SET_SELECTED_BOOKING', eventObject);

				if (event.type === 'booking') {
					const {
						booking_dates,
						booking_dates_times,
						company,
						start_time,
						end_time,
						lunch,
						notes,
						id: bookingId,
						profession,
						rates,
						experience,
						request_dates,
						accountid,
						skills,
					} = eventObject;

					const booking = {
						start_time,
						end_time,
						lunch,
						notes,
						booking_dates,
						booking_dates_times,
						id: bookingId,
						profession,
						rates,
						experience,
						request_dates,
						accountid,
						skills,
					};

					store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewUpcomingBooking' });
					bus.$emit('change-context', 'view-practice-details-card');
				} else if (event.type === 'offer') {
					this.locumViewBookingRequest(eventObject);
				} else if (event.type === 'avail') {
					const { available_dates, start_time, end_time, id: availabilityId, status, availability_code, request_dates } = eventObject;

					const booking = { start_time, end_time, booking_dates: available_dates, id: availabilityId, status, availability_code, request_dates };

					store.dispatch('setLocumViewingPractice', { booking, source: 'viewLocumAvailability' });
					bus.$emit('change-context', 'view-practice-details-card');
				} else if (event.type === 'viewApplicationSent') {
					const {
						booking_dates,
						booking_dates_times,
						company,
						start_time,
						end_time,
						lunch,
						notes,
						id: bookingId,
						profession,
						rates,
						experience,
						request_dates,
						id: accountid,
						skills,
					} = eventObject;

					const booking = {
						start_time,
						end_time,
						lunch,
						notes,
						booking_dates,
						booking_dates_times,
						id: bookingId,
						profession,
						rates,
						experience,
						request_dates,
						accountid,
						skills,
					};

					store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewApplicationSent' });
					bus.$emit('change-context', 'view-practice-details-card');
				} else {
					this.selectedEvent = event;
					this.selectedElement = nativeEvent.target;
					setTimeout(() => (this.selectedOpen = true), 10);
				}
			};

			if (this.selectedOpen) {
				this.selectedOpen = false;
				setTimeout(open, 10);
			} else {
				open();
			}

			nativeEvent.stopPropagation();
		},

		locumViewBookingRequest(requestSet) {
			const { offer, availability } = requestSet;

			if (offer) {
				this.viewPrivateRequest(requestSet);
			}
			if (availability) {
				this.viewPublicRequest(requestSet);
			}
		},

		viewPrivateRequest(requestSet) {
			const { offer, request } = requestSet;
			const { booking_dates, booking_dates_times } = request;

			const { id: offerId, company, profession, rates, experience, start_time, end_time, lunch, notes, request_dates, skills } = offer;

			const booking = { start_time, end_time, lunch, notes, booking_dates, booking_dates_times, id: offerId, profession, rates, experience, request_dates, skills };

			store.dispatch('setLocumPracticeRequestSelected', requestSet);
			store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewBookingRequest' });
			bus.$emit('change-context', 'view-practice-details-card');
		},

		viewPublicRequest(requestSet) {
			const { availability, request } = requestSet;

			const { id: availabilityId, date } = availability;
			const { id: companyId, booking_dates, booking_dates_times, rates, experience, industry, start_time, end_time, lunch, notes, request_dates, skills } = request;

			const booking = {
				start_time,
				end_time,
				lunch,
				notes,
				booking_dates,
				booking_dates_times,
				date,
				industry,
				id: availabilityId,
				rates,
				experience,
				request_dates,
				skills,
			};

			store.dispatch('setLocumPracticeRequestSelected', requestSet);
			store.dispatch('setLocumViewingPractice', { id: companyId, booking, source: 'viewBookingRequest' });
			bus.$emit('change-context', 'view-practice-details-card');
		},

		async getAvailabilities(startDate, endDate) {
			await this.LoadProfessionalAvailability({
				startDate,
				endDate,
			});

			const getDateField = set => set['available_dates'];

			const getAvailEntry = (start, end, avail) => {
				const { id, status, date, isdeleted, start_time, end_time } = avail;
				if (!isdeleted) {
					return {
						id,
						name: status === 'unavailable' ? 'Unavailable' : 'Available',
						start: start + ' ' + start_time,
						end: end + ' ' + end_time,
						color: status === 'unavailable' ? 'red' : 'primary',
						type: 'avail',
						eventStart: date,
						eventObject: avail,
					};
				}
			};
			const avails = (await this.getGroupedDates(this.professionalAvailability, getDateField, getAvailEntry)) || [];

			return avails.filter(x => {
				const exists = this.bookings.find(y => y.start === x.start && y.end === x.end);
				return exists ? false : true;
			});
		},

		async getBookingRequests(startDate, endDate) {
			await this.SearchOffers({
				startDate,
				endDate,
			});

			const bookingRequests = this.professionalBookingsRequests.filter(
				set =>
					moment(set.request.booking_dates[0]).isSame(startDate, 'month') ||
					moment(set.request.booking_dates[set.request.booking_dates.length - 1]).isSame(endDate, 'month')
			);
			const getDateField = set => set['request']['booking_dates'];

			const getBookingReqObject = (start, end, set) => {
				const { offer, availability } = set;

				if (offer) {
					return {
						id: offer.id,
						name: 'Booking Request',
						start: start + ' ' + moment(offer.request_dates[0].start_time).format('HH:mm'),
						end: end + ' ' + offer.end_time,
						color: 'light-blue darken-2',
						type: 'offer',
						eventStart: set.request.booking_dates[0],
						eventObject: set,
						// booking.booking_dates_times.length === 0
						// 		? booking.request_dates.length === 0
						// 			? start + ' ' + booking.start_time
						// 			: start + ' ' + moment(booking.request_dates[0].start_time).format('HH:mm')
						// 		: start + ' ' + moment(booking.booking_dates_times[0].start_time).format('HH:mm'),
					};
				} else if (availability) {
					return {
						id: availability.id,
						name: 'Booking Request',
						start: start + ' ' + set.request.start_time,
						end: end + ' ' + set.request.end_time,
						color: 'light-blue darken-2',
						type: 'offer',
						eventStart: set.request.booking_dates[0],
						eventObject: set,
					};
				}
			};
			const bookingReqs = (await this.getGroupedDates(bookingRequests, getDateField, getBookingReqObject)) || [];
			return bookingReqs.filter(x => {
				const exists = this.bookings.find(y => y.start === x.start && y.end === x.end);
				return exists ? false : true;
			});
		},

		async getConfirmedBookings(startDate, endDate) {
			await this.LoadProfessionalBookings({
				startDate,
				endDate,
			});

			const getDateField = set => set['booking_dates'];

			const getBookingEntry = (start, end, booking) => {
				if (booking.status !== Booking.STATUS.CANCELLED && (moment(booking.start_date).isSame(startDate, 'month') || moment(booking.end_date).isSame(endDate, 'month'))) {
					return {
						id: booking.id,
						name: booking.status === 'confirmed' ? 'Confirmed Booking' : 'Unavailable',
						start: booking.request_dates.length === 0 ? start + ' ' + booking.start_time : start + ' ' + moment(booking.request_dates[0].start_time).format('HH:mm'),
						end: end + ' ' + booking.end_time,
						color: 'light-green darken-1',
						type: 'booking',
						eventStart: booking.start_date,
						eventObject: booking,
					};
				}
			};
			const confirmedBookings = (await this.getGroupedDates(this.professionalConfirmedBookings, getDateField, getBookingEntry)) || [];
			return confirmedBookings;
			// Removed because it is causing to overwrite the bookings with null on second refresh
			// return confirmedBookings.filter(x => {
			// 	const exists = this.bookings.find(y => y.start === x.start && y.end === x.end);
			// 	return exists ? false : true;
			// });
		},

		async getApplicationsSent(startDate, endDate) {
			if (typeof startDate === 'string' && typeof endDate === 'string') {
				const offersRequests = await this.FetchOffers({ startDate, endDate, offersType: 'locum-applications-sent' });
				const getDateField = set => set['booking_dates'];
				const getBookingEntry = (start, end, applicationSent) => ({
					id: applicationSent.id,
					name: 'Application Sent',
					start: applicationSent.booking_dates[0],
					end: applicationSent.booking_dates[applicationSent.booking_dates.length - 1],
					color: this.tenant.settings.workflow.professionalCalendar.eventColors.applicationSent,
					type: 'viewApplicationSent',
					eventStart: applicationSent.start_date,
					eventObject: applicationSent,
				});
				let offersArr = [];
				for (let i = 0; i < offersRequests.length; i++) {
					const combinedData = Object.assign({}, offersRequests[i].request, offersRequests[i].offer); //{ ...offersRequests[i].request, ...offersRequests[i].offer };
					offersArr.push(combinedData);
				}
				const applicationsSent = (await this.getGroupedDates(offersArr, getDateField, getBookingEntry)) || [];
				return applicationsSent;
			}
		},

		async updateRange({ start, end }) {
			const bookings = await this.getConfirmedBookings(start.date, end.date);
			this.bookings = bookings;
			const avails = await this.getAvailabilities(start.date, end.date);
			const bookingReq = await this.getBookingRequests(start.date, end.date);
			const applicationSent = await this.getApplicationsSent(start.date, end.date);
			this.start = start;
			this.end = end;

			//LBK-12: Do not show available on the dates where there is a confirmed booking
			//This loop removes the available event on the days where there is a confirmed booking
			//Only for front end/calendar purposes, not in DB
			for (let i = 0; i < avails.length; i++) {
				const originalAvailStartTime = avails[i].start.toString().substr(12, 5);
				const originalAvailEndTime = avails[i].end.toString().substr(12, 5);
				bookings.forEach(booking => {
					if (booking.eventStart >= avails[i].eventStart && booking.eventStart <= avails[i].end.toString().substr(0, 10)) {
						let currentDate = new Date(avails[i].eventStart);
						while (currentDate <= booking.eventStart) {
							currentDate.setDate(currentDate.getDate() + 1);
						}
						booking.start = new Date(booking.start);
						let newEndDate = new Date(booking.start);
						newEndDate.setDate(booking.start.getDate() - 1);
						avails[i].end = avails[i].end.replace(avails[i].end.toString().substr(0, 10), newEndDate.toISOString().split('T')[0]);
						if (booking.end.toString().substr(0, 10) >= avails[i].eventStart && booking.end.toString().substr(0, 10) <= avails[i].end.toString().substr(0, 10)) {
							//set new start date of new Availability to Confirmed Booking Last day + 1
							booking.end = new Date(booking.end);
							let newStartDate = new Date(booking.end);
							newStartDate.setDate(booking.end.getDate() + 1);
							avails.push({
								id: avails[i].id,
								name: avails[i].status === 'unavailable' ? 'Unavailable' : 'Available',
								start: newStartDate.toISOString().split('T')[0] + ' ' + originalAvailStartTime,
								end: avails[i].end.replace(avails[i].end.toString().substr(0, 10), newEndDate.toISOString().split('T')[0]), //originalAvailEndDate + ' ' + originalAvailEndTime,
								color: avails[i].status === 'unavailable' ? 'red' : 'primary',
								type: 'avail',
								eventStart: newStartDate.toISOString().split('T')[0],
								eventObject: avails[i].eventObject,
							});
						} else if (
							booking.start.toString().substr(0, 10) >= avails[i].eventStart &&
							booking.start.toString().substr(0, 10) >= avails[i].end.toString().substr(0, 10) &&
							booking.end.toString().substr(0, 10) >= avails[i].eventStart &&
							booking.end.toString().substr(0, 10) >= avails[i].end.toString().substr(0, 10)
						) {
							//set new start date of new Availability to Confirmed Booking Last day + 1
							booking.end = new Date(booking.end);
							let newStartDate = new Date(booking.end);
							newStartDate.setDate(booking.end.getDate() + 1);
							avails.push({
								id: avails[i].id,
								name: avails[i].status === 'unavailable' ? 'Unavailable' : 'Available',
								start: newStartDate.toISOString().split('T')[0] + ' ' + originalAvailStartTime,
								end: avails[i].end.replace(avails[i].end.toString().substr(0, 10), newEndDate.toISOString().split('T')[0]),
								color: avails[i].status === 'unavailable' ? 'red' : 'primary',
								type: 'avail',
								eventStart: newStartDate.toISOString().split('T')[0],
								eventObject: avails[i].eventObject,
							});
						}
					} else if (booking.end.toString().substr(0, 10) >= avails[i].eventStart && booking.end.toString().substr(0, 10) <= avails[i].end.toString().substr(0, 10)) {
						if (booking.end.toString().substr(0, 10) >= avails[i].eventStart && booking.end.toString().substr(0, 10) <= avails[i].end.toString().substr(0, 10)) {
							//set new start date of new Availability to Confirmed Booking Last day + 1
							booking.end = new Date(booking.end);
							let newStartDate = new Date(booking.end);
							newStartDate.setDate(booking.end.getDate() + 1);
							avails.push({
								id: avails[i].id,
								name: avails[i].status === 'unavailable' ? 'Unavailable' : 'Available',
								start: newStartDate.toISOString().split('T')[0] + ' ' + originalAvailStartTime,
								end: avails[i].end.toString().substr(0, 10) + ' ' + originalAvailEndTime,
								color: avails[i].status === 'unavailable' ? 'red' : 'primary',
								type: 'avail',
								eventStart: newStartDate.toISOString().split('T')[0],
								eventObject: avails[i].eventObject,
							});
						}
						avails.splice(i, 1);
					}
				});
			}
			this.avails = avails;

			this.bookingRequests = bookingReq;
			this.applicationsSent = applicationSent;
		},

		nth(d) {
			return d > 3 && d < 21 ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
		},

		refreshCalander() {
			this.updateRange({ start: this.start, end: this.end });
		},

		async getGroupedDates(events, getDatesField, getEvent) {
			const groupedDates = [];
			try {
				const pushEvent = (start, end, event) => {
					const eventBody = getEvent(start, end, event);
					if (eventBody) {
						return groupedDates.push(eventBody);
					}
					return;
				};

				if (!events) {
					return [];
				}
				for (const event of events) {
					let datesGroup = [];

					const eventDates = getDatesField(event);
					if (!eventDates) continue;

					eventDates.forEach((date, index) => {
						const dateMinusOne = moment(date).subtract(1, 'days').format('YYYY-MM-DD');
						const datePlusOne = moment(date).add(1, 'days').format('YYYY-MM-DD');
						const previousDate = eventDates[index - 1];
						const nextDate = eventDates[index + 1];

						const isFirst = index === 0;
						const isLast = index === eventDates.length - 1;

						if (isFirst) {
							if (datePlusOne === nextDate) {
								datesGroup.push(date);
							} else {
								pushEvent(date, date, event);
							}
						}

						if (eventDates.length === 1) {
							return;
						}

						if (isLast) {
							if (dateMinusOne === previousDate) {
								datesGroup.push(date);
								pushEvent(datesGroup[0], datesGroup[datesGroup.length - 1], event);
								datesGroup = [];
							} else {
								pushEvent(date, date, event);
							}
						}

						if (!isLast && !isFirst) {
							if (dateMinusOne === previousDate && datePlusOne === nextDate) {
								datesGroup.push(date);
							}
							if (dateMinusOne === previousDate && datePlusOne !== nextDate) {
								datesGroup.push(date);
								pushEvent(datesGroup[0], datesGroup[datesGroup.length - 1], event);
								datesGroup = [];
							}
							if (dateMinusOne !== previousDate && datePlusOne === nextDate) {
								datesGroup.push(date);
							}
							if (dateMinusOne !== previousDate && datePlusOne !== nextDate) {
								pushEvent(date, date, event);
							}
						}
					});
				}
			} catch (error) {
				return [];
			}
			return groupedDates;
		},
	},
};
</script>

<style scoped>
.v-calendar-weekly,
.v-calendar-monthly {
	border: none;
}

.v-calendar-weekly__head-weekday,
.v-calendar-daily_head-weekday {
	font-size: 16px;
}
</style>
